import { useMedia } from 'react-use';
import { useKeenSlider } from 'keen-slider/react';

import TileItem from '../../components/TileItem/TileItem';
import { SliderControlDiv, StyledHeading, OfferContainer } from '../TilesSection/styles';
import React, { useState } from 'react';
import { Box, Text } from '@chakra-ui/react';

export interface TileSectionProps {
    title?: string;
    subtitle?: string;
    titleLeft?: Boolean;
    adding?: string;
    tilesSettings?: '2x1' | '3x1' | '4x1';
    tiles: TileItem[];
}

function Arrow(props: { disabled: boolean; left?: boolean; onClick: (e: any) => void }) {
    const disabeld = props.disabled ? ' arrow--disabled' : '';
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${props.left ? 'arrow--left' : 'arrow--right'} ${disabeld}`}
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="13"
            viewBox="0 0 8 13"
        >
            {props.left && (
                <path d="M8.00001 0.730469L5.54012 0.730469L0.363648 6.74354L5.54012 12.7305L8.00001 12.7305L2.82354 6.74354L8.00001 0.730469Z" />
            )}
            {!props.left && (
                <path d="M1.52588e-05 12.7305H2.45991L7.63638 6.7174L2.45991 0.730469H1.52588e-05L5.17649 6.7174L1.52588e-05 12.7305Z" />
            )}
        </svg>
    );
}

const ChakraTilesSection = ({
    title,
    subtitle,
    adding,
    titleLeft,
    tilesSettings = '2x1',
    tiles,
}: TileSectionProps) => {
    //TODO  move breakpoint to cosntants
    const isMobile = useMedia('(max-width: 780px)');

    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [loaded, setLoaded] = useState(false);
    const [keenSliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    return (
        <>
            <Box width={titleLeft ? '370px' : '100%'}>
                {title && (
                    <Text
                        textAlign="left"
                        fontSize="34px"
                        fontWeight={'bold'}
                        className="text-wrapper"
                        mb={{ base: '20px' }}
                        width={'100%'}
                    >
                        {title}
                    </Text>
                )}
                <Text mb={{ base: '20px' }}>{subtitle}</Text>
                <Text fontSize="12px" lineHeight={'19px'}>
                    {adding}
                </Text>
            </Box>
            {isMobile ? (
                <>
                    <Box bg="dark.1" ref={keenSliderRef} className="keen-slider">
                        {tiles.map((tileitem, index) => (
                            <div key={index} className={`keen-slider__slide number-slide${index}`}>
                                <TileItem
                                    title={tileitem.title}
                                    content={tileitem.content}
                                    link={tileitem.link ? tileitem.link : ''}
                                    key={index}
                                />
                            </div>
                        ))}
                    </Box>
                    <SliderControlDiv>
                        {loaded && instanceRef.current && (
                            <>
                                <div
                                    style={{
                                        cursor: 'pointer',
                                        width: '20px',
                                    }}
                                >
                                    <Arrow
                                        left
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.prev()
                                        }
                                        disabled={currentSlide === 0}
                                    />
                                </div>
                                <span
                                    style={{
                                        margin: '0px 30px',
                                    }}
                                >
                                    {currentSlide + 1} / {tiles.length}{' '}
                                </span>
                                <div
                                    style={{
                                        cursor: 'pointer',
                                        width: '20px',
                                    }}
                                >
                                    <Arrow
                                        onClick={(e: any) =>
                                            e.stopPropagation() || instanceRef.current?.next()
                                        }
                                        disabled={
                                            currentSlide ===
                                            instanceRef.current.track.details.slides.length - 1
                                        }
                                    />
                                </div>
                            </>
                        )}
                    </SliderControlDiv>
                </>
            ) : (
                <OfferContainer $tilesSettings={tilesSettings}>
                    {tiles.map((tileitem, index) => (
                        <TileItem
                            title={tileitem.title}
                            content={tileitem.content}
                            link={tileitem.link}
                            logoImage={tileitem.logoImage}
                            key={index}
                        />
                    ))}
                </OfferContainer>
            )}
        </>
    );
};

export default ChakraTilesSection;
